export const Header = () => {
  return (
    <div className="w-full sticky-header py-2 font-light text-xs text-white bg-cyan-600 z-50">
      <div className="container">
        <div className="marquee-wrapper overflow-hidden">
          <div className="animate-marquee-wrapper flex">
           <div className="animate-marquee whitespace-nowrap animate-marquee-1">
  A hub of innovation and creativity with a long-term vision to create meaningful change.
</div>
<div className="animate-marquee whitespace-nowrap animate-marquee-2 ml-96">
  Based in Jakarta, we build a creative industry ecosystem through strategic collaboration for a more dynamic future.
</div>

          </div>
        </div>
      </div>
    </div>
  );
};
